import { baseApi } from '@/api/core/baseApi';
import type { Schema } from '@voley/shared-types';
import type { ApprovedNumber } from '../types';

export const approvedNumberApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getApprovedNumbers: build.query<ApprovedNumber[], void>({
      query: () => ({ url: '/approved-numbers', method: 'GET' }),
      transformResponse: (resp: Schema<'PlatformApprovedNumbersListResponse'>) => resp.data,
      providesTags: (result) =>
        result
          ? [
              ...result.map((n) => ({ type: 'ApprovedNumber' as const, id: n.id })),
              { type: 'ApprovedNumber' as const, id: 'LIST' },
            ]
          : [{ type: 'ApprovedNumber' as const, id: 'LIST' }],
    }),
  }),
});

export const { useGetApprovedNumbersQuery } = approvedNumberApi;
